import { SUBSCRIPTION_STATE } from '../constants'

/**
 * Uses the requested and received SPiDR [subscription] services to determine
 *      the SDK subscription status for each service.
 * @method parseSpidrServices
 * @param  {Array}  requested The list of requested SPiDR services.
 * @param  {Array}  received The list of received SPiDR services.
 * @return {Object} Information about the SDK's subscriptions.
 */
export function parseSpidrServices (requested, received) {
  // UC platform is not case-sensitive (Link is), so filter without caring about case.
  const upperReceived = received.map(service => service.toUpperCase())

  // Find the missing services.
  const missing = requested.filter(function (reqService) {
    // If the requested service was received (not caring about case),
    //      it is not missing.
    return upperReceived.indexOf(reqService.toUpperCase()) === -1
  })

  const subscriptions = {
    requested,
    received,
    missing,
    status: 'UNKNOWN',
    services: {}
  }

  // Determine the overall subscription status.
  if (received.length === 0) {
    subscriptions.status = SUBSCRIPTION_STATE.NONE
  } else if (received.length > 0 && missing.length > 0) {
    subscriptions.status = SUBSCRIPTION_STATE.PARTIAL
  } else if (received.length > 0 && requested.length === received.length) {
    subscriptions.status = SUBSCRIPTION_STATE.FULL
  } else {
    // Should never reach this case.
  }

  // List the individual service statuses.
  received.forEach(function (service) {
    subscriptions.services[service] = true
  })
  missing.forEach(function (service) {
    subscriptions.services[service] = false
  })

  return subscriptions
}
